import React, { FC } from 'react';
import { Icon, IconButton } from '@kontentino/ui';
import dayjs, { Dayjs } from 'dayjs';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';

type Props = Pick<
  ReactDatePickerCustomHeaderProps,
  'decreaseMonth' | 'increaseMonth' | 'date'
> & {
  minDate?: Dayjs;
  maxDate?: Dayjs;
  monthsShown?: number;
  customHeaderCount?: number;
};

const DatePickerHeaderMonthNav: FC<Props> = ({
  decreaseMonth,
  increaseMonth,
  date,
  minDate,
  maxDate,
  monthsShown = 1,
  customHeaderCount = 0,
}) => {
  const year = date.getFullYear();

  const isNextMonthDisabled = maxDate
    ? dayjs(date).add(1, 'month').isAfter(maxDate.endOf('month'))
    : false;

  const isPreviousMonthDisabled = minDate
    ? dayjs(date).subtract(1, 'month').isBefore(minDate.startOf('month'))
    : false;

  const isFirstMonth = customHeaderCount === 0;
  const isLastMonth = customHeaderCount === monthsShown - 1;

  return (
    <div className="tw-flex tw-items-center tw-justify-between">
      <span className="tw-text-md tw-font-medium tw-capitalize">
        {dayjs(date).format('MMMM')} {year}
      </span>
      <div className="tw-flex tw-gap-x-1">
        {isFirstMonth && (
          <IconButton
            onClick={decreaseMonth}
            variant="light"
            icon={<Icon size={'md'} icon={faChevronLeft} />}
            size={'small'}
            disabled={isPreviousMonthDisabled}
            data-cy="datepicker_previous-month"
          />
        )}
        {isLastMonth && (
          <IconButton
            onClick={increaseMonth}
            variant="light"
            icon={<Icon size={'md'} icon={faChevronRight} />}
            size={'small'}
            disabled={isNextMonthDisabled}
            data-cy="datepicker_next-month"
          />
        )}
      </div>
    </div>
  );
};

export default DatePickerHeaderMonthNav;
